import { lazy } from 'react-loosely-lazy';

export const LazyVirtualServiceAgentChatSidebar = lazy(
	() =>
		import(
			/* webpackChunkName: "virtual-service-agent-chat-sidebar" */ './virtual-service-agent-chat-sidebar'
		),
);
